import {
    faDatabase,
    faQuestion,
    faBacteria,
    faLocationCrosshairs,
    faHandHoldingDollar,
    faEnvelope, faList
} from "@fortawesome/free-solid-svg-icons";
import facebook from "../../images/brands/facebook.svg";
import google from "../../images/brands/google-ads.svg";
import bsShop from "../../images/brands/bs-shop.svg";
import shoptet from "../../images/brands/shoptet.svg";
import sklik from "../../images/brands/sklik.svg";
import zbozi from "../../images/brands/zbozi.svg";
import heureka from "../../images/brands/heureka.svg";
import shopify from "../../images/brands/shopify.svg";
import upgates from "../../images/brands/upgates.svg";
import glami from "../../images/brands/glami.svg";
import {faSquareLetterboxd} from "@fortawesome/free-brands-svg-icons";
import {useTranslation} from "react-i18next";

export function useBrands() {

    let {t} = useTranslation();

    return {
        //
        // === MARKETING CHANNELS
        //
        'Meta': {
            'name': t('brand.name.facebook-ads'),
            'slug': 'meta',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': facebook,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
      //      'helpArticleId': 204000025235,
        },
        'Google': {
            'name': t('brand.name.google-ads'),
            'slug': 'google',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': google,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
          //  'helpArticleId': 204000025236,
        },
        'Sklik': {
            'name': 'Sklik.cz',
            'slug': 'sklik',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': sklik,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        //    'helpArticleId': 204000025241,
        },
        'Zbozi': {
            'name': 'Zbozi.cz',
            'slug': 'zbozi',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': zbozi,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        },
        'Heureka': {
            'name': 'Heureka',
            'slug': 'heureka',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': heureka,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
         //   'helpArticleId': 204000015029,
        },
        'Glami': {
            'name': 'Glami',
            'slug': 'glami',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': glami,
            'isAdSystem': true,
            'isERP': false,
            'isLead': false,
        //    'helpArticleId': 204000025242,
        },
        //
        // === ERP/LEAD SOURCES
        //
        'MySQLLead': {
            'name': t('brand.name.mysql-leads'),
            'slug': 'mysql',
            'bg': 'bg-[#EEEEEE]',
            'text': 'text-[#9999FF]',
            'icon': faDatabase,
            'isAdSystem': false,
            'isERP': false,
            'isLead': true,
        },
        'BsShop': {
            'name': 'BSSHOP',
            'slug': 'bsshop',
            'bg': 'bg-[#1D2123]',
            'text': 'text-[#FFFFFF]',
            'icon': bsShop,
            'isAdSystem': false,
            'isERP': true,
            'isLead': false,
          //  'helpArticleId': 204000025238,
        },
        'Shoptet': {
            'name': 'Shoptet',
            'slug': 'shoptet',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': shoptet,
            'isAdSystem': false,
            'isERP': true,
            'isLead': false,
          //  'helpArticleId': 204000025237,
        },
        /*'Shopify': {
            'name': 'Shopify',
            'slug': 'shopify',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': shopify,
            'isAdSystem': false,
            'isERP': true,
            'isLead': false,
        },*/
        'Upgates': {
            'name': 'Upgates',
            'slug': 'upgates',
            'bg': 'bg-[#f1f1f1]',
            'text': 'text-white',
            'icon': upgates,
            'isAdSystem': false,
            'isERP': true,
            'isLead': false,
        },

        //
        // === AFFILIATE/MAILING
        //

        'Affiliate': {
            'name': t('brand.name.affiliate'),
            'slug': 'affiliate',
            'bg': 'bg-[#2D2926]',
            'text': 'text-[#ed6f63]',
            'icon': faHandHoldingDollar,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },
        'Mailing': {
            'name': t('brand.name.mailing'),
            'slug': 'mailing',
            'bg': 'bg-[#6E6E6D]',
            'text': 'text-[#FAD0C9]',
            'icon': faEnvelope,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },
        'Other': {
            'name': t('brand.name.other'),
            'slug': 'other',
            'bg': 'bg-[#333333]',
            'text': 'text-[#04ce04]',
            'icon': faHandHoldingDollar,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },

        //
        // === GENERIC
        //

        'Direct': {
            'name': t('brand.name.direct'),
            'slug': 'direct',
            'bg': 'bg-[#101820]',
            'text': 'text-[#F2AA4C]',
            'icon': faLocationCrosshairs,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },
        'Organic': {
            'name': t('brand.name.organic'),
            'slug': 'organic',
            'bg': 'bg-[#A07855]',
            'text': 'text-[#D4B996]',
            'icon': faBacteria,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },

        //
        // === UNKNOWN
        //

        'Unknown': {
            'name': t('brand.name.unknown'),
            'slug': 'unknown',
            'bg': 'bg-[#7b9acc]',
            'text': 'text-[#FCF6F5]',
            'icon': faList,
            'isAdSystem': false,
            'isERP': false,
            'isLead': false,
        },
    };
}

export function useBrand(findBy) {
    let brands = useBrands();

    // first, try to find by key (a.k.a. integration name)
    for(let key of Object.keys(brands)) {
        if (key === findBy) {
            return brands[key];
        }
    }

    // second, try to find by slug
    for(let brand of Object.values(brands)) {
        if (brand.slug === findBy) {
            return brand;
        }
    }

    return null;
}

export function useAdSystemBrands() {
    let brands = useBrands();

    let brandList = [];

    for(let brand of Object.values(brands)) {
        if (brand?.isAdSystem === true) {
            brandList.push(brand);
        }
    }

    return brandList;
}

export function useErpBrands() {
    let brands = useBrands();

    let brandList = [];

    for(let brand of Object.values(brands)) {
        if (brand?.isERP === true) {
            brandList.push(brand);
        }
    }

    return brandList;
}

export function useLeadBrands() {
    let brands = useBrands();

    let brandList = [];

    for(let brand of Object.values(brands)) {
        if (brand?.isLead === true) {
            brandList.push(brand);
        }
    }

    return brandList;
}
